/**
 * 盤點 detail／comparison 的物料巢狀：契約權威 `material`／`materialNo`；
 * `mtr`／`mtrNo` 為相容舊別名。
 */
export function resolveLineMaterial(row) {
  return row?.material ?? row?.mtr ?? null;
}

export function resolveLineMaterialNo(material) {
  return material?.materialNo ?? material?.mtrNo ?? '';
}
